export const creacionDivOpacidad = (contenedorCapa, layer) => {
  //control de opacidad
  const divControlOpacidad = document.createElement("div");
  divControlOpacidad.className = "control-opacidad";

  const controlOpacidad = document.createElement("input");
  controlOpacidad.type = "range";
  controlOpacidad.min = 0;
  controlOpacidad.max = 1;
  controlOpacidad.value = 0.5;
  controlOpacidad.step = 0.1;

  function update() {
    const opacity = parseFloat(controlOpacidad.value);
    layer.setOpacity(opacity);
    controlOpacidad.innerText = opacity.toFixed(2);
  }

  controlOpacidad.addEventListener("input", update);

  // update();

  divControlOpacidad.appendChild(controlOpacidad);
  contenedorCapa.appendChild(divControlOpacidad);
};
